import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { map, catchError } from 'rxjs/operators';
import { URL_LOGIN, URL_USER_RESERVATIONS, URL_LOGOUT, MOCK_LOGIN, MOCK_STATUS, MOCK_URL_USER_RESERVATION, MOCK_URL_LOGOUT } from '@ibe.config';
import { INDRAApiService } from './api.indra.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@ngrx/store";
import * as i3 from "./api.indra.service";
var INDRAAuthenticationService = /** @class */ (function () {
    function INDRAAuthenticationService(http, store, api) {
        this.http = http;
        this.store = store;
        this.api = api;
        this.URL = './assets/data/user_info.json';
        this.httpError = null;
    }
    INDRAAuthenticationService.prototype.authenticate = function (credentials) {
        var _this = this;
        return this.http.get(this.URL)
            .pipe(map(function (res) {
            var authUser = null;
            if (credentials) {
                res.forEach(function (user) {
                    if (user.email === credentials.user) {
                        authUser = user;
                    }
                });
                if (authUser)
                    return authUser;
                else
                    return res[0];
            }
        }), catchError(function (error) { return _this.handleError(error); }));
    };
    INDRAAuthenticationService.prototype.INDRA_login = function (user, pass) {
        var data = {
            password: pass,
            username: user
        };
        if (MOCK_STATUS.LOGIN) {
            return this.api.INDRA_get(MOCK_LOGIN);
        }
        else {
            return this.api.INDRA_post(URL_LOGIN, data);
        }
    };
    INDRAAuthenticationService.prototype.INDRA_SocialLogin = function (user, type) {
        var data = {
            username: user,
            authenticationType: type
        };
        // if (MOCK_STATUS.LOGIN) {
        // return this.api.INDRA_get<INDRAUserData>(MOCK_LOGIN);
        // } else {
        return this.api.INDRA_post(URL_LOGIN, data);
        // }
    };
    INDRAAuthenticationService.prototype.INDRA_loginCookie = function () {
        return this.api.INDRA_post(URL_LOGIN, {});
    };
    INDRAAuthenticationService.prototype.INDRA_getUserReservations = function (tapID, frequentFlyerNumber) {
        if (MOCK_STATUS.LOGIN) {
            return this.api.INDRA_get(MOCK_URL_USER_RESERVATION);
        }
        else {
            var data = {
                'tapId': tapID,
                'ffNumber': frequentFlyerNumber
            };
            return this.api.INDRA_post(URL_USER_RESERVATIONS, data);
        }
    };
    INDRAAuthenticationService.prototype.INDRA_logout = function () {
        if (MOCK_STATUS.LOGOUT) {
            return this.api.INDRA_get(MOCK_URL_LOGOUT);
        }
        else {
            return this.api.INDRA_post(URL_LOGOUT, {});
        }
    };
    INDRAAuthenticationService.prototype.handleError = function (error) {
        this.httpError = error;
        throw new Error('login error: ' + error.statusText);
    };
    INDRAAuthenticationService.ngInjectableDef = i0.defineInjectable({ factory: function INDRAAuthenticationService_Factory() { return new INDRAAuthenticationService(i0.inject(i1.HttpClient), i0.inject(i2.Store), i0.inject(i3.INDRAApiService)); }, token: INDRAAuthenticationService, providedIn: "root" });
    return INDRAAuthenticationService;
}());
export { INDRAAuthenticationService };
